import { createContext } from 'react';

export type SidebarContextType = {
  desktop: null | {
    /**
     * Some routes (i.e, Discover) disallow docking the sidenav to allow
     * optimal screen space.
     */
    canExpandOnRoute: boolean;
    /**
     * For use in conjunction with `expand` in the context of hovering only
     */
    collapse: () => void;
    /**
     * For use with hover only. The expanded state is a temporarly state
     */
    expand: () => void;
    isExpanded: boolean;
  };
  disableScrollPrevention: boolean;
  isMenuExpanded: boolean;
  layout: 'COMPACT' | 'DEFAULT';
  mobile: null | {
    close: () => void;
    isOpen: boolean;
    open: () => void;
  };
  style: {
    display: 'block' | 'none';
    paddingRight: string;
    width: string;
    zIndex: number;
  };
};

export const SidebarContext = createContext<SidebarContextType>({
  desktop: null,
  disableScrollPrevention: false,
  isMenuExpanded: false,
  layout: 'DEFAULT',
  mobile: null,
  style: {
    display: 'none',
    paddingRight: '0px',
    width: '0px',
    zIndex: 0,
  },
});
